<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/my_company/drivers"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="mobile">
          <Input type="text" v-model="searchData.mobile" placeholder="手机号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="car_number">
          <Input type="text" v-model="searchData.car_number" placeholder="车牌号" class="lx-search-item"></Input>
        </FormItem>
        <FormItem prop="create_time">
          <DatePicker v-model="searchData.create_time" type="datetimerange" placeholder="注册时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <!--<template v-slot:otherBtn>
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>-->

    </pageTable>

    <edit-form v-if="showEdit"
               :show-edit="showEdit"
               :user_id="editUserId"
               ref="editModel"
               @cancel-edit="showEdit=false"
    >
    </edit-form>


    <Modal
            v-model="daohangModal.isShow"
            :title="daohangModal.title"
            :loading="daohangModal.isLoading"
            @on-ok="editDaohangNum"
            @on-cancel="cancelDaohangModal">
      <Form ref="unitPriceForm" :label-width="100" :model="daohangModal">
        <FormItem label="次数" prop="num">
          <Input v-model="daohangModal.num" placeholder="负数则减去次数" maxlength="100"></Input>
        </FormItem>
      </Form>
    </Modal>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import editForm from "./driverDetail";
  import XLSX from 'xlsx'
  export default {
    name: "driver",
    components:{pageTable,editForm},
    data() {
      return {
        showEdit:false,
        editUserId:0,     //编辑的用户ID
        searchData: {
          mobile: '',
          nick_name:'',
          is_member:'',
          car_number:'',
          create_time:''
        },
        tableColumn: [
          {title: 'ID',key: 'user_id',align: "center"},
          {title: '手机号',key: 'mobile',align: "center"},
          {title: '微信名',key: 'nick_name',align: "center"},
          {title: '姓名',key: 'user_name',align: "center"},
          {title: '车牌号',key: 'car_number',align: "center"},
          {title: '车队卡余额',key: 'balance',align: "center"},
          {title: 'OBD设备号',key: 'obd_device',align: "center"},
          {title: '导航次数',key: 'daohang_num',align: "center",render:(h,params)=>{
              return h('div',[
                h('span',params.row.daohang_num),
                h('Icon',{
                  props:{type:'md-add',style:{marginLeft:'5px'}},
                  on:{click:()=> {this.showDaohangModal(params.row)}}
                }),
              ])
            }},
          // {title: '油耗',key: 'fuel_economy',align: "center"},
          {title: '注册时间',key: 'create_time',align: "center"},
          {title: '详情',align: "center",render:(h,params)=>{
            return h('div',[
                h('Button',
                  {
                    props: {type:'primary',size:'small'},
                    on:{
                      click:()=>{this.showDetail(params.row.user_id)}
                    },
                  },'查看')
            ])
            }},
        ],
        tableData: [],
        daohangModal:{
          isShow:false,
          isLoading:false,
          driver_id:0,
          title:'',
          num:'',
        }
      }
    },
    methods: {
      showDetail(user_id){
        this.editUserId = user_id
        this.showEdit = true
      },
      reloadDetail(user_id){
        this.showEdit = false
        this.$nextTick(()=>{
          this.showDetail(user_id)
        })
      },
      showDaohangModal(info){
        this.$Modal.confirm({
          title:'确定要赠送导航次数吗',
          loading:true,
          onOk: async ()=>{
            let res = await this.$commonFun.postProxy('admin/my_company/editDriverDaohangNum',{user_id:info.user_id});
            this.$Modal.remove()
            this.$commonFun.dealApiResult(res,()=>{
              this.$commonFun.successTip(res.msg)
              this.$refs.table.getLists();
            })
          }
        })
        /*this.daohangModal.isShow = true
        this.daohangModal.user_id = info.user_id
        this.daohangModal.title = info.car_number + ' - ' + info.mobile*/
      },
      cancelDaohangModal(){
        this.daohangModal.isShow = false
        this.daohangModal.user_id = 0
      },
      async editDaohangNum(){
        this.daohangModal.isLoading = true
        let res = await this.$commonFun.postProxy('admin/my_company/editDriverDaohangNum',{user_id:this.daohangModal.user_id,num:this.daohangModal.num});
        this.daohangModal.isLoading = false
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$refs.table.getLists();
          })
        })
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
